import React, { useState, useContext } from 'react';
import { Paper, InputBase, Button, IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { makeStyles, fade } from '@material-ui/core/styles';
import storeApi from '../../utils/storeApi';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  card: {
    width: '270px',

    padding: theme.spacing(1, 1, 1, 2),
    paddingBottom: theme.spacing(4),
    margin: theme.spacing(0, 1, 1, 1),
  },
  confirm: {
    margin: theme.spacing(1, 1, 1, 3),
  },

  btnAddCard: {
    background: '#5AAC44',
    color: '#fff',
    '&:hover': {
      backgroundColor: fade('#5AAC44', 0.75),
    },
  },
}));
export default function InputCard({ handleClose, type, listId }) {
  const classes = useStyles();
  const store = useContext(storeApi);
  const [inputValue, setInputValue] = useState();
  const handleOnChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleAddItem = async (e) => {
    e.preventDefault();
    if (type === 'card') {
      store.addMoreCard(inputValue, listId);
      handleClose();
      setInputValue(null);
    } else {
      store.addMoreList(inputValue);
      handleClose();
      setInputValue(null);
    }
  };

  return (
    <>
      <div className={classes.root}>
        <Paper className={classes.card} elevation={1}>
          <InputBase
            value={inputValue ? inputValue : ''}
            onBlur={handleClose}
            autoFocus
            multiline
            fullWidth
            placeholder={
              type === 'card'
                ? 'Enter a title of this card..'
                : 'Enter list Title..'
            }
            onChange={handleOnChange}
          />
        </Paper>
      </div>
      <div className={classes.confirm}>
        <Button className={classes.btnAddCard} onClick={handleAddItem}>
          {type === 'card' ? 'AddCard' : 'Add List'}
        </Button>
        <IconButton onClick={handleClose}>
          <ClearIcon />
        </IconButton>
      </div>
    </>
  );
}
